/**
 * Auth Adapter Sözleşmesi (Faz 6).
 *
 * Tüm auth implementasyonları (Mock, JWT, Auth0, OAuth, vb.) bu arayüzü
 * uygulamak zorundadır. UI kodu (PrivateRoute, useAuth hook'u) yalnızca bu
 * sözleşmeye bağlıdır — somut implementasyon swap edilebilir.
 *
 * @typedef {Object} AuthUser
 * @property {string} id
 * @property {string} email
 * @property {string} name
 * @property {string} [avatar]
 *
 * @typedef {Object} IAuthAdapter
 * @property {() => Promise<AuthUser | null>} getUser
 * @property {() => boolean} isAuthenticated
 * @property {() => string | null} getToken
 * @property {(email: string, password: string) => Promise<AuthUser>} signIn
 * @property {() => Promise<void>} signOut
 */

// JSDoc tanımı; gerçek tip kontrolü Faz 11'de TypeScript'e geçişle gelir.
export const AUTH_TOKEN_KEY = "auth_token";
export const AUTH_USER_KEY = "auth_user";
